import * as React from "react";
import { Box } from "@mui/material";
import CustomTypography from "../form/CustomTypography";

interface CircularProgressWithLabelProps {
  value: number;
  height: number;
}

const CircularProgressWithLabel: React.FC<CircularProgressWithLabelProps> = ({
  value,
  height,
}) => {
  const radius = height / 2 - 6;
  const strokeWidth = height / 8;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = ((100 - value) / 100) * circumference;

  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <svg width={height} height={height}>
        <circle
          cx={height / 2}
          cy={height / 2}
          r={radius}
          stroke="#e0e0e0"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx={height / 2}
          cy={height / 2}
          r={radius}
          stroke="url(#gradient)"
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          transform={`rotate(-90 ${height / 2} ${height / 2})`}
        />
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#52E6CA" />
            <stop offset="100%" stopColor="#7567F8" />
          </linearGradient>
        </defs>
      </svg>
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CustomTypography
          style={{ color: "#7567F8", fontWeight: 700 }}
          variant="heading8"
        >{`${Math.round(value)}%`}</CustomTypography>
      </Box>
    </Box>
  );
};

interface CircularProgressBarProps {
  progress: number;
  height: number;
}

const CircularProgressBar: React.FC<CircularProgressBarProps> = ({
  progress,
  height,
}) => {
  return <CircularProgressWithLabel value={progress} height={height} />;
};

export default CircularProgressBar;
